<template>
  <div>
    <material-card>
      <v-toolbar slot="header" color="primary">
        <v-toolbar-title>Gift Cards</v-toolbar-title>
        <v-spacer></v-spacer>
        <ComponentSearchBar :searchColumns="filteredSearchColumn" @search-query="getGiftCard" />
        <v-spacer></v-spacer>
        <v-menu
      offset-y
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="ma-2"
          outlined
          color="white"
          v-if="loggedUser.role === '1'"
        >Actions</v-btn>
      </template>

      <v-list>
        <v-list-item
          link
          @click="cancelMultipleGiftCards()"
        >
          <v-list-item-title>Cancel giftcards</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          @click="groupBy = 'package_name'"
        >
          <v-list-item-title>Group by batch</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
      </v-toolbar>
      <v-data-table v-model="selected" :headers="giftcardTable.headers" :items="giftcardTable.data"
        :options.sync="giftcardTableOptions" :server-items-length="giftcardTable.total" :loading="giftcardTable.loading"
        item-key="giftcard_id" dense class="elevation-0" :footer-props="{
          'items-per-page-options': [25, 50, 100, 250, 500, 1000]
        }" :items-per-page="500" show-select :group-by="groupBy"
    show-group-by>
        <template slot="headerCell" slot-scope="{ header }">
          <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
        </template>
        <template v-slot:item.cancelled="{ item }">
      <v-chip
       v-if="item.cancelled"
        color="warning"
        small
        dark
      >
        Cancelled
      </v-chip>
    </template>
    <template v-slot:item.used="{ item }">
      <v-chip
       v-if="item.used"
        color="success"
        small
        dark
      >
        Used
      </v-chip>
    </template>
        <template v-if="canRequestGiftcard" v-slot:item.client_name="{ item }">
          <a :href="item.link" dark>{{ item.client_name }}</a>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small @click="cancelSingleGiftcard(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </material-card>

    <v-dialog v-model="giftcardDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>Request Gift Card</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-form ref="giftcardRequest" v-model="giftcardRequest.valid">
            <v-select v-model="giftcardRequest.giftCardMerchant" :items="campaignMerchants" item-value="campaign_id"
              item-text="name" label="Merchant" return-object :rules="[v => !!v || 'Merchant is required']"></v-select>
            <v-text-field v-model="giftcardRequest.giftcardAmount" type="number" min="0" label="Number of Gift Cards"
              :rules="[v => (v && v.length > 0) || 'Field is required']"></v-text-field>
            <v-text-field v-model="giftcardRequest.giftcardValue" type="number" min="0" label="Value"
              :rules="[v => (v && v.length > 0) || 'Field is required']"></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="secondary darken-1" outlined @click="giftcardDialog = false">Cancel</v-btn>
          <v-btn color="primary darken-1" @click="requestGiftcards(); giftcardDialog = false">Request Gift Cards</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import apiService from '@/services'
import moment from 'moment'
import ComponentSearchBar from '@/components/common-components/ComponentSearchBar.vue'

export default {
  components: {
    ComponentSearchBar
  },
  props: {
    campaignMerchants: {
      type: Array,
      default () {
        return []
      }
    },
    canRequestGiftcard: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    console.log('Campaign Merchants', this.campaignMerchants)
    this.getGiftCard(this.$route.params.campaignId)
  },
  watch: {
    giftcardTableOptions: {
      handler () {
        this.getGiftCard(this.$route.params.campaignId)
      },
      deep: true
    }
  },
  data () {
    return {
      selected: [],
      groupBy: undefined,
      giftcardTable: {
        headers: [
          {
            text: 'Id',
            value: 'giftcard_id',
            sortable: true,
            groupable: false
          },
          {
            text: 'Client',
            value: 'client_name',
            sortable: true,
            groupable: false
          },
          {
            text: 'Merchant',
            value: 'merchant_name',
            sortable: true,
            groupable: false
          },
          {
            text: 'Scanned',
            value: 'scanned',
            sortable: true,
            groupable: false
          },
          {
            text: 'Used',
            value: 'used',
            sortable: true,
            groupable: false
          },
          {
            text: 'Cancelled',
            value: 'cancelled',
            sortable: true,
            groupable: false
          },
          {
            text: 'Value (€)',
            value: 'value',
            sortable: true,
            groupable: false
          },
          {
            text: 'Creation date',
            value: 'formattedDate',
            sortable: true,
            groupable: false
          },
          {
            text: 'Actions',
            value: 'action',
            sortable: false,
            searchable: false,
            groupable: false
          }
        ],
        options: {},
        data: [],
        total: 0,
        loading: true,
        totals: {}
      },
      giftcardTableOptions: {},
      giftcardDialog: false,
      giftcardRequest: {
        valid: true,
        giftcardMerchant: '',
        giftcardAmount: null,
        giftcardValue: null
      }
    }
  },
  computed: {
    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out unsearchable headers
      return this.giftcardTable.headers.filter((item) => item.searchable !== false)
    },
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    }
  },
  methods: {
    cancelSingleGiftcard (giftCardId) {
      console.log('Single giftcard delete ', giftCardId)
      this.cancelGiftcardAction([giftCardId])
    },
    cancelMultipleGiftCards () {
      if (this.selected.length > 0) {
        this.cancelGiftcardAction(this.selected)
      }
    },
    async cancelGiftcardAction (giftcardsList) {
      this.giftcardTable.loading = true
      try {
        const payload = giftcardsList.map(giftcard => {
          return giftcard.giftcard_id
        })
        const response = await apiService.cancelGiftCard(payload)
        console.log('response', response)
        await this.getGiftCard(this.$route.params.campaignId)
        this.selected = []
        this.giftcardTable.loading = false
      } catch (error) {
        console.log(error.message)
        this.selected = []
        this.giftcardTable.loading = false
      }
    },

    /**
     * Get qcodes of the Merchant
     */
    getGiftCard (searchParams = {}) {
      this.giftcardTable.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.giftcardTableOptions
      const campaignId = this.$route.params.campaignId

      let filter = {}
      filter.sort_by = sortBy[0] || 'campaign_name'
      filter.descending = sortDesc[0]
      filter.page = page
      filter.limit = itemsPerPage * 1

      filter.id = campaignId
      filter.campaign_id = campaignId

      filter.search_filter =
        !!searchParams && searchParams.tableSearch !== ''
          ? searchParams.searchColumn
          : ''
      filter.search_value = searchParams.tableSearch || ''

      console.log('pre post ', filter)

      apiService
        .getGiftCardsList(filter)
        .then((response) => {
          console.log('response', response)
          const data = response.data

          // Format dates to DD-MM-YYYY HH:mm
          data.map(val => {
            val.formattedDate = moment(val.date).format('DD-MM-YYYY HH:mm')
          })

          this.giftcardTable.data = data
          this.giftcardTable.data.map(i => {
            i.totalGiftcards = i.available + i.used
            return i
          })

          // this.giftcardTable.total = response.data.count
          this.giftcardTable.total = response.data.length || 0

          this.giftcardTable.loading = false
          // this.giftcardTable.totals = response.data.totals
        })
        .catch((error) => {
          this.giftcardTable.loading = false
          console.error(error)
        })
    },

    getCampaignGiftCards (campaignId, searchParams = {}) {
      this.nposTable.loading = true
      // Hide rigth drawer
      this.rightDrawer = false

      const { sortBy, sortDesc, page, itemsPerPage } = this.nposTableOptions
      // const campaignId = this.$route.params.campaignId

      let filter = {}
      filter.orderBy = sortBy[0] || null
      filter.orderDesc = sortDesc[0] || null
      filter.page = page
      filter.limit = itemsPerPage * 1

      filter.search_filter =
        !!searchParams && searchParams.tableSearch !== ''
          ? searchParams.searchColumn
          : ''
      filter.search_value = searchParams.tableSearch || ''

      apiService
        .getGiftCardsList(campaignId, filter)
        .then((response) => {
          //  Take only email of the tech rep
          this.nposTable.data = response.map((el) => {
            return {
              ...el,
              area: el.area.map((e) => e.name)
            }
          })
          this.nposTable.total = response.length
          this.nposTable.loading = false
        })
        .catch(() => {
          this.nposTable.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Unable to get campaign Npos'
          })
        })
    },

    /**
     * Request GiftCard for merchant
     */
    revokeGiftCard () {
      let data = {}
      if (this.$refs.giftcardRequest.validate()) {
        data.campaign_id = this.$route.params.campaignId
        data.merchant_id = this.giftcardRequest.giftCardMerchant.id
        data.client_id = this.giftcardRequest.giftCardMerchant.id
        data.gift_card_size = this.giftcardRequest.giftcardValue
        data.gift_card_num = this.giftcardRequest.giftcardAmount

        apiService
          .revokeGiftCard(data)
          .then((response) => {
            this.$store.dispatch('alert/success', 'Giftcard requested successfully')
            this.getGiftCard(this.$route.params.campaignId)
          })
          .catch((error) => {
            this.$store.dispatch('alert/error', error.response.data.message)
          })

        // if (valid) {
        //   const data = {
        //     campaign_id: this.giftcardRequest.giftCardMerchant.campaign_id,
        //     amount: this.giftcardRequest.giftcardAmount
        //   }
        //   apiService
        //     .requestGiftcards(data)
        //     .then((response) => {
        //       this.$store.dispatch('alert/success', 'Giftcard requested successfully')
        //       this.getGiftCard(this.$route.params.campaignId)
        //     })
        //     .catch((error) => {
        //       this.$store.dispatch('alert/error', error.response.data.message)
        //     })
        // }
      } else {
        console.log('Form not valid')
      }
    }
  }
}
</script>
